var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-line',{attrs:{"config":{points: _vm.points, stroke: _vm.color, strokeWidth: _vm.width}}})}
var staticRenderFns = []

export { render, staticRenderFns }